"use client";
import { useEffect } from "react";
import { useJourneySession } from "@/hooks/useJourneySession";
import { useLookupStore } from "@/stores/lookupStore";
import { useOnboardingStore } from "@/stores/onboardingStore";
import { lookupMatchesPublicParams } from "@/utilities/signup-lookup";
import type { MultipleNmiAddressSelectContent, NmiSearchModalContent } from "@/sanity/queries";
import { ProductResults } from "./ProductResults";
import { ProductPlaceholder } from "./Product/ProductPlaceholder";

export function SessionProductResults({
	energy,
	promo,
	restart,
	nmiSearchModalContent,
	multipleNmiAddressSelectContent,
}: {
	energy?: string;
	promo?: string;
	restart?: string;
	nmiSearchModalContent?: NmiSearchModalContent | null;
	multipleNmiAddressSelectContent?: MultipleNmiAddressSelectContent | null;
}) {
	const ready = useJourneySession(restart === "1");
	const lookup = useLookupStore(state => state.lookup);
	const matches = lookup && lookupMatchesPublicParams(lookup, energy, promo);
	useEffect(() => {
		if (ready && !matches) useOnboardingStore.getState().clearOnboardingData();
	}, [ready, matches]);
	if (!ready || !lookup || !matches) return <ProductPlaceholder />;
	return (
		<ProductResults
			key={lookup.revision}
			energy={lookup.energy}
			promo={lookup.promo}
			address={lookup.kind === "address" ? lookup.address : undefined}
			addressKey={lookup.kind === "address" ? lookup.addressKey : undefined}
			nmi={lookup.kind === "nmi" ? lookup.nmi : undefined}
			nmiSearchModalContent={nmiSearchModalContent}
			multipleNmiAddressSelectContent={multipleNmiAddressSelectContent}
		/>
	);
}
